import React, { useState, useEffect, useRef, ChangeEvent } from "react";
import Input from "../../Input";

type TProps = {
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  filters: {
    miles: string;
  };
  handleFilterChange: (field: string, value: string) => void;
}

export default function InputMiles({
  label,
  placeholder,
  disabled,
  filters,
  handleFilterChange
}: TProps) {
  const [numeric, setNumeric] = useState<string>(filters.miles || '0');
  const milesRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setNumeric(filters.miles && filters.miles !== '' ? filters.miles : '0');
  }, [filters.miles]);

  const handleMilesChange = (e: ChangeEvent<HTMLInputElement>) => {
    const digits = (e.target.value || '').replace(/\D/g, '');

    if (digits === '') {
      setNumeric('0');
      handleFilterChange('miles', '');
    } else {
      const normalized = digits.replace(/^0+/, '') || '0';
      setNumeric(normalized);
      handleFilterChange('miles', normalized);
    }
  };

  const setCaretToNumberEnd = () => {
    const input = milesRef.current;
    if (!input) return;
    const pos = (numeric || '').length;
    try {
      input.setSelectionRange(pos, pos);
    } catch { }
  };

  const handleMilesFocus = () => {
    if (numeric === '0') {
      setNumeric('');
    }

    requestAnimationFrame(setCaretToNumberEnd);
  };

  useEffect(() => {
    setCaretToNumberEnd();
  }, [numeric]);

  return (
    <Input
      ref={milesRef}
      label={label}
      value={`${numeric} milhas`}
      placeholder={placeholder}
      disabled={disabled}
      onClick={setCaretToNumberEnd}
      onChange={handleMilesChange}
      onFocus={handleMilesFocus}
      onKeyUp={setCaretToNumberEnd}
      onMouseUp={(e: React.MouseEvent<HTMLInputElement>) => {
        e.preventDefault();
        setCaretToNumberEnd();
      }}
      onBlur={() => {
        if (numeric === '') {
          setNumeric('0');
        }
      }}
    />
  )
}